var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChefs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "36px",
    viewBox: "0 0 41 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Membership-subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-Up-00",
    transform: "translate(-924.000000, -603.000000)",
    fill: "#DE3530",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(882.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.49952,470 C57.9674906,470 54.1767125,473.148051 53.2037794,477.340738 C52.6737424,477.24877 52.1242793,477.200114 51.5666325,477.200114 C46.2992902,477.200114 42,481.446801 42,486.650053 C42,491.390772 45.5815487,495.295622 50.1999707,495.959368 L50.1999707,504.649936 C50.1999707,505.008086 50.3439176,505.35149 50.6003619,505.604493 C50.8564809,505.857801 51.2041255,506 51.5667057,506 L73.4332943,506 C73.7958664,506 74.143511,505.857809 74.3996381,505.604493 C74.6560742,505.351498 74.8000293,505.008094 74.8000293,504.649936 L74.8000293,495.959368 C79.4184513,495.295172 83,491.390692 83,486.650053 C83,481.446962 78.7005471,477.200114 73.4333675,477.200114 C72.87568,477.200114 72.3262901,477.248768 71.7962206,477.340738 C70.8228808,473.148051 67.0322654,470 62.50048,470 L62.49952,470 Z M62.4998867,473 C65.9073648,473 68.6462967,475.812401 68.8195339,479.373991 C68.8425534,479.796752 69.0517912,480.183538 69.3846894,480.417765 C69.7175875,480.651991 70.1354723,480.706385 70.5120537,480.564729 C71.1864023,480.30832 71.9029382,480.172299 72.653759,480.172299 C76.1739584,480.172299 79,483.166974 79,486.896509 C79,490.626045 76.1739584,493.62072 72.653759,493.62072 C72.3173251,493.62072 71.9944601,493.762368 71.7562947,494.014718 C71.5184316,494.26706 71.3847374,494.608842 71.3847374,494.965634 L71.3847374,499 L53.6152626,499 L53.6152626,494.965634 C53.6152626,494.60885 53.481576,494.267068 53.2437053,494.014718 C53.0055475,493.762376 52.6826825,493.62072 52.346241,493.62072 C48.8260416,493.62072 46,490.626045 46,486.896509 C46,483.166974 48.8260416,480.172299 52.346241,480.172299 C53.097024,480.172299 53.8135826,480.30832 54.4879463,480.564729 C54.8645201,480.706377 55.2824352,480.651967 55.6153106,480.417765 C55.9481861,480.183562 56.1574458,479.796752 56.1804661,479.373991 C56.3537033,475.812401 59.0927108,473 62.5001133,473 L62.4998867,473 Z M54,502 L71,502 L71,504 L54,504 L54,502 Z",
    id: "Shape"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefs);
export default __webpack_public_path__ + "static/media/chefs.c172dee1e5e7557c5b5f58198649ffce.svg";
export { ForwardRef as ReactComponent };